module.exports = __webpack_public_path__ + "static/widget-img-2-3be392f47bc5238840a63a0cb12f54d2.png";